export default __webpack_public_path__ + "static/media/goopter-flashbot-taking-elevator.2f058ee4.jpg";